type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const JvStatus = Object.freeze({
  USE: 1 as const, // ใช้งาน
  CANCEL: 2 as const, // ลบ
});

export type JvStatus = EnumLiteralsOf<typeof JvStatus>;
